module.exports = __webpack_public_path__ + "static/tiesto_0-394e45523c5576d09b897cd186eb90e5.jpg";